<template>
  <el-table-column
    prop="target_storage_name"
    sortable="custom"
    label="Cél raktár"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.target_storage_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'target_storage_name',
  };
</script>
